import React from "react";
import { Building2 } from "lucide-react";

// Single shared "who is this company" visual — mirrors CandidateAvatar.jsx so
// both entities render consistently everywhere (job cards, job detail,
// company public profile, companies list, employer dashboard/profile).
export function CompanyAvatar({ name, logo, size = 40, rounded = 12 }) {
  const initial = (name || "").trim().charAt(0).toUpperCase();
  return (
    <div
      data-testid="company-avatar"
      style={{
        width: size, height: size, borderRadius: rounded, flexShrink: 0, overflow: "hidden",
        background: logo ? "#F1F5F9" : "#028CF8",
        display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
        fontWeight: 700, fontFamily: "Poppins, sans-serif", fontSize: Math.max(11, Math.round(size * 0.42)),
      }}
    >
      {logo ? (
        <img src={logo} alt={name || "Company"} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : initial ? (
        initial
      ) : (
        <Building2 style={{ width: size * 0.5, height: size * 0.5 }} />
      )}
    </div>
  );
}
